export default value => {
  if (value == null) return '-';

  if (value >= 1000) {
    return (value / 1000).toFixed(2) + ' sec';
  }

  return Math.round(value * 10) / 10 + ' ms';
};
